<template>
    <div
        class="planAlokasiChart"
        ref="defectDeliveryUnitEkspedisiChart"
        style="width: 100%; height: 500px"
    ></div>
</template>

<script>
/* Imports */
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

export default {
    name: "ColumnBarChart",
    data() {
        return {
            chart: null,
            colors: [
                "#83A2FF",
                "#FF83A2",
                "#83FFE0",
                "#FFE083",
                "#C8FFA3",
                "#DABAFF",
            ],
        };
    },
    props: ["data"],
    mounted() {
        this.createChart();
    },
    beforeDestroy() {
        if (this.chart) this.chart.dispose();
    },
    watch: {
        data: {
            deep: true,
            handler: "updateChart",
        },
    },
    methods: {
        updateChart(newData) {
            const totalColor = [];
            let letters = "3456789ABCDE".split("");
            for (let i = 0; i < this.data.length; i++) {
                let color = "#";
                for (let j = 0; j < 6; j++) {
                    color +=
                        letters[Math.floor(Math.random() * letters.length)];
                }
                totalColor.push(color);
            }
            let data =
                newData && newData.length > 0
                    ? newData.map((x, i) => {
                          return {
                              ekspedisi_kode: x.ekspedisi_kode,
                              total: (
                                  (x.jumlahrusak / x.jumlahangkut) *
                                  100
                              ).toFixed(2),
                              jumlahrusak: x.jumlahrusak,
                              jumlahangkut: x.jumlahangkut,
                              jumlahpengiriman: Number(x.jumlahrusak) + Number(x.jumlahangkut),
                              color: totalColor[i % totalColor.length],
                          };
                      })
                    : [
                          {
                              ekspedisi_kode: "No Data",
                              total: 1,
                              color: "#83A2FF",
                              jumlahrusak: 0,
                              jumlahangkut: 0,
                              jumlahpengiriman: 0
                          },
                      ];
            this.chart.data = data;
        },
        createChart() {
            // Apply the animated theme for some basic chart animations
            am4core.useTheme(am4themes_animated);

            // Create the chart instance
            this.chart = am4core.create(
                this.$refs.defectDeliveryUnitEkspedisiChart,
                am4charts.XYChart
            );

            // Create axes
            let categoryAxis = this.chart.xAxes.push(
                new am4charts.CategoryAxis()
            );
            categoryAxis.dataFields.category = "ekspedisi_kode";
            categoryAxis.renderer.grid.template.location = 0;

            let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.title.text = "Total Bongkar";
            valueAxis.extraMax = 0.1; // Add extra space at the top

            let percentageAxis = this.chart.yAxes.push(
                new am4charts.ValueAxis()
            );
            percentageAxis.renderer.opposite = true;
            percentageAxis.title.text = "Defect Percentage (%)";
            percentageAxis.renderer.grid.template.disabled = true;
            percentageAxis.syncWithAxis = valueAxis; // Synchronize zooming

            // Rotate the title of the percentage axis
            percentageAxis.title.rotation = 270;
            percentageAxis.title.align = "center"; // Align the title to the center
            percentageAxis.title.dy = -10; // Adjust position

            // Create column series for total angkut
            let columnSeries = this.chart.series.push(
                new am4charts.ColumnSeries()
            );
            columnSeries.dataFields.valueY = "jumlahpengiriman";
            columnSeries.dataFields.categoryX = "ekspedisi_kode";
            columnSeries.name = "Total Bongkar";
            columnSeries.columns.template.width = am4core.percent(80);
            columnSeries.columns.template.strokeWidth = 0;
            columnSeries.columns.template.propertyFields.fill = "color";

            // Set column properties
            let columnTemplate = columnSeries.columns.template;
            columnTemplate.strokeWidth = 0;
            columnTemplate.strokeOpacity = 0;
            columnTemplate.column.cornerRadiusTopLeft = 5;
            columnTemplate.column.cornerRadiusTopRight = 5;

            // Add labels to the columns
            let labelBullet = columnSeries.bullets.push(
                new am4charts.LabelBullet()
            );
            labelBullet.label.html = `<span style="color: #BB3E3E; font-size: 14px;">&#x25A0;</span> {jumlahrusak}`; // Red square character
            labelBullet.label.text = "{jumlahrusak}";
            labelBullet.label.fill = am4core.color("#BB3E3E");
            labelBullet.label.dy = -10; // Adjust position of the label

            // Add a new label for total_angkut
            let labelBullet2 = columnSeries.bullets.push(
                new am4charts.LabelBullet()
            );
            labelBullet2.label.text = "{valueY}";
            labelBullet2.label.fill = am4core.color("#000000");
            labelBullet2.locationY = 0.5; // Position label in the middle of the bar

            // Create line series for defect percentage
            let lineSeries = this.chart.series.push(new am4charts.LineSeries());
            lineSeries.dataFields.valueY = "total";
            lineSeries.dataFields.categoryX = "ekspedisi_kode";
            lineSeries.yAxis = percentageAxis;
            lineSeries.name = "Defect Percentage";
            lineSeries.stroke = am4core.color("#84EB71"); // Line color
            lineSeries.strokeWidth = 2;
            lineSeries.tooltipText = "{name}: [bold]{valueY}[/]";
            lineSeries.tooltip.getFillFromObject = false; // IMPORTANT for customizing tooltip style
            lineSeries.tooltip.background.fill = am4core.color("#84EB71"); // tooltip background color
            lineSeries.tooltip.label.fill = am4core.color("#125E1E"); // tooltip font color

            // Add square bullets to the line series
            const bullet = lineSeries.bullets.push(new am4charts.Bullet());
            const square = bullet.createChild(am4core.Rectangle);
            square.width = 10;
            square.height = 10;
            square.horizontalCenter = "middle";
            square.verticalCenter = "middle";
            square.fill = am4core.color("#84EB71"); // Change bullet color

            // Add legend for column series
            this.chart.legend = new am4charts.Legend();
            this.chart.legend.position = "top";
            this.chart.legend.contentAlign = "right";
            this.chart.legend.valign = "right";
            this.chart.legend.marginBottom = 10; // Add some bottom spacing to the legend

            // Add items to the legend
            let legendData = [
                {
                    name: "Total Bongkar",
                    fill: "#000000",
                    bullet: "<span style='font-size:14px;color:#000000;'>&#x25A0;</span>",
                },
                {
                    name: "Defect Unit",
                    fill: "#BB3E3E",
                    bullet: "<span style='font-size:14px;color:#BB3E3E;'>&#x25A0;</span>",
                },
            ];
            this.chart.legend.data = legendData;
            this.chart.legend.useDefaultMarker = true;

            // Customize the legend items to include the bullet
            this.chart.legend.markers.template.width = 18;
            this.chart.legend.markers.template.height = 18;
            let marker =
                this.chart.legend.markers.template.children.getIndex(0);
            marker.cornerRadius(0, 0, 0, 0);
            marker.strokeWidth = 0;

            // Add chart cursor
            this.chart.cursor = new am4charts.XYCursor();

            // Add separate legend for line series
            let lineLegend = new am4charts.Legend();
            lineLegend.parent = this.chart.chartContainer;
            lineLegend.data = [
                {
                    name: "Defect Percentage",
                    fill: "#84EB71",
                    bullet: "<span style='font-size:14px;color:#84EB71;'>&#x25A0;</span>",
                },
            ];
            lineLegend.position = "bottom";
            lineLegend.contentAlign = "center";

            // Add scrollbar
            let scrollbarX = new am4core.Scrollbar();
            this.chart.scrollbarX = scrollbarX;
            this.chart.scrollbarX.parent = this.chart.bottomAxesContainer;
            this.chart.scrollbarX.startGrip.hide();
            this.chart.scrollbarX.endGrip.hide();

            // Apply pre-zoom after chart is loaded
            this.chart.events.on("datavalidated", () => {
                categoryAxis.start = 0;
                categoryAxis.end = 0.5;
                categoryAxis.keepSelection = true;
            });

            this.chart.zoomOutButton = new am4core.ZoomOutButton();
            this.chart.zoomOutButton.hide();

            // Update the chart with initial data
            this.updateChart(this.data);
        },
        addLegends() {
            // Add legend for column series
            this.chart.legend = new am4charts.Legend();
            this.chart.legend.position = "top";
            this.chart.legend.contentAlign = "right";
            this.chart.legend.valign = "right";

            // Add legend for line series
            this.lineSeriesLegend = new am4charts.Legend();
            this.lineSeriesLegend.position = "bottom";
            this.lineSeriesLegend.contentAlign = "center";
        },
        updateLegend() {
            // Update legend for line series
            this.lineSeriesLegend.data = [
                {
                    name: "Defect Percentage",
                    fill: "#84EB71",
                    bullet: "<span style='font-size:14px;color:#84EB71;'>&#x25A0;</span>",
                },
            ];
        },
    },
};
</script>

<style>
/* Add any custom styles here if needed */
</style>
